import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationComponent } from './navigation/navigation.component';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, NavigationComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.sass',
  standalone: true,
  providers: []
})
export class AppComponent implements OnInit {

  title = 'principle-ui';
  domain = '';

  /*------------------------------------------
  --------------------------------------------
  constructor
  --------------------------------------------
  --------------------------------------------*/
  constructor(@Inject(DOCUMENT) private document: Document) { }

  /*------------------------------------------
  --------------------------------------------
  ngOnInit
  --------------------------------------------
  --------------------------------------------*/
  ngOnInit() {
      this.domain = this.document.location.hostname;
      const [subdomain] = this.domain.split('.');
      if(subdomain) {
        console.log(subdomain);
        this.document.documentElement.classList.add(subdomain + '-theme');
      }
  }
}
